/*
 * Copyright (c) 2013 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of 2013 SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	Timeout.js
 *
 * Description:	Contains the functionality for locking the screen after a certain timeout period, forcing the user
 *				to re-enter thier password in order to continue.
 *
 * History:		01-JUL-13	S  Brown	Initial implementation.
 *              17-JAN-17   M Bajer		Removed timeout if SSO User (DR085)
 *
 */	
	// This should be difined in the calling page:
	// var c_iTimeOutSecs = ""							// The timeout period in seconds.

	var g_oTimeout = null;								// Contains our code to execute when the tiomeout period has elapsed.
	var g_oLoginDetails = null;							// An encrypted string containing our login object.
	var c_szCookieName = "SGSInsightAuth"; 				// The name of our cookie containing the encrypted login object.
	var g_bAuthenticationRqd = false;					// Flag to indicate whether authentication is currently rqd (i.e, is the popup showing).
		
	// Call the update to set our timeout
	// code with the delay set to the timeout period.
	to_Update();

	// Set / Reset the timout period.
	function to_Update() {
	    if (typeof (g_oUserProfile) !== "undefined" && g_oUserProfile.authenticationMode == 0) {
	        if (c_iTimeOutSecs > 0) {
	            if (g_oTimeout != null)
	                clearTimeout(g_oTimeout);
	            g_oTimeout = setTimeout("to_processTimeOut();", c_iTimeOutSecs * 1000);
	        }
	    }
	}

	// Forces the current session to be logged out
	function to_forceLogOut(){
		
		// Expire the cookie.
		var oDate = new Date();
		oDate.setUTCFullYear(oDate.getUTCFullYear() - 1);
		setCookieEx(c_szCookieName, "", oDate.toUTCString());
			
		// Reset the held encrypted login details and redirect the user
		// to the login page. We leave the password box displayed incase 
	    // the user clicks the browsers back button.
		if (g_oUserProfile.authenticationMode == 0) {
		    g_oLoginDetails = null;
		    window.location = "default.aspx";
		}
		else {
		    g_oLoginDetails = null;
		    window.location = "default.aspx?SLO=1";
		}
	}

	// Processes the timeout event.
	function to_processTimeOut(){

		g_bAuthenticationRqd = true;

		// Expire the cookie.
		g_oLoginDetails = getCookie(c_szCookieName);
		var oDate = new Date();
		oDate.setUTCFullYear(oDate.getUTCFullYear() - 1);
		setCookieEx(c_szCookieName, "", oDate.toUTCString());

		lockWindow();
		displaySessionExpiredPopup();
	}

	// ReAuthenticates the user when a password has been provided.
	function to_reAuthenticate(){
			
		// If the held encrypted login details is null, then we
		// redirect the user to the login page to perform a full log on.
		if(isNothing(g_oLoginDetails))
			window.location = "default.aspx";
		else {
			// Perform another Log In.
			if (to_validateReEnteredPassword()) {
					
				// Build up a JSON object to pass to the server.
				var oJSON = new Object();
				oJSON.password = $("#hidSHAReAuthenticate").val();
				$("#hidSHAReAuthenticate").val(""); 		// Clear the password. We dont want this held within the page.

				uploadContent("apps/portal/svr/Default.aspx", "REAUTHENTICATE", oJSON, "to_reAuthenticateCallback();");
			}
		}
	}

	// Callback for handling the result of the users re-authentication.
	function to_reAuthenticateCallback(){
		if (g_oCLData.Success){
				
			// Return the user to the current page.			
			unlockWindow();
			hideSessionExpiredPopup();
			g_bAuthenticationRqd = false;

			// Reset the timeout period.
			to_Update();
		} else {

			// Log the user out properly.
			to_forceLogOut();
		}
	}

	// Validates the password value provided when requesting the user re-authenticates themselves.
	function to_validateReEnteredPassword(){
		if(trim($("#txtReAuthenticate").val()).length > 0){
			$("#txtReAuthenticate").removeClass("insightTextBoxLrgError");
			$("#txtReAuthenticate").addClass("insightTextBoxLrg");
			$("#hidSHAReAuthenticate").val(sha1(trim($("#txtReAuthenticate").val())));
			return true;
		} else {
			$("#txtReAuthenticate").removeClass("insightTextBoxLrg");
			$("#txtReAuthenticate").addClass("insightTextBoxLrgError");
			return false;
		}
	}
